export default function BeforeAfter() {
  const rows = [
    {
      before: { text: 'Боится звонить', desc: 'Страх перед трубкой, неуверенный голос, желание быстрее закончить разговор.' },
      after: { text: 'Спокойно начинает разговор', desc: 'Уверенный тон, чёткая цель звонка, готовность к любому сценарию.' },
    },
    {
      before: { text: 'Читает скрипт', desc: 'Монотонное зачитывание текста, клиент чувствует фальшь и теряет интерес.' },
      after: { text: 'Ведёт живой диалог', desc: 'Естественная речь, адаптация под реакцию клиента, вовлекающие вопросы.' },
    },
    {
      before: { text: 'Пытается продать', desc: 'Давит на клиента, презентует продукт до выявления потребности.' },
      after: { text: 'Назначает следующий шаг', desc: 'Цель — встреча или договорённость, а не сиюминутная продажа.' },
    },
    {
      before: { text: 'Боится отказов', desc: 'Каждое «нет» воспринимает как личную неудачу, теряет мотивацию.' },
      after: { text: 'Использует отказ как начало переговоров', desc: '«Нет» — это точка входа в диалог, а не его конец.' },
    },
    {
      before: { text: 'Делает десятки бесполезных звонков', desc: 'Хаотичный обзвон без системы и без результата.' },
      after: { text: 'Повышает конверсию каждого контакта', desc: 'Осмысленная работа с базой, каждый звонок приближает к цели.' },
    },
  ];

  return (
    <section id="before-after" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            До обучения / После обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Посмотрите, как меняется поведение менеджеров после прохождения программы.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="overflow-hidden rounded-2xl border border-gray-200">
            {/* Header */}
            <div className="grid grid-cols-2 bg-gray-100">
              <div className="p-4 md:p-6 text-center border-r border-gray-200">
                <div className="flex items-center justify-center gap-2 text-red-600 font-bold text-lg">
                  <i className="ri-close-circle-line text-xl"></i>
                  До обучения
                </div>
              </div>
              <div className="p-4 md:p-6 text-center">
                <div className="flex items-center justify-center gap-2 text-teal-600 font-bold text-lg">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                  После обучения
                </div>
              </div>
            </div>

            {/* Rows */}
            {rows.map((row, i) => (
              <div key={i} className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                <div className="p-4 md:p-6 border-r border-gray-100 flex items-start gap-3">
                  <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-line text-red-500 text-sm"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm md:text-base mb-1">{row.before.text}</div>
                    <div className="text-gray-500 text-xs md:text-sm leading-relaxed">{row.before.desc}</div>
                  </div>
                </div>
                <div className="p-4 md:p-6 flex items-start gap-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm md:text-base mb-1">{row.after.text}</div>
                    <div className="text-gray-500 text-xs md:text-sm leading-relaxed">{row.after.desc}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Хочу такие же изменения в отделе продаж
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}